
<!-- TEMPLATE -->
<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright">
        {{ dateStamp }} Powered by
        <a href="https://www.dcodx.com/" target="https://www.dcodx.com"
          >DCODX</a
        >
      </div>
    </div>
  </footer>
</template>

<!-- SCRIPT -->
<script>
export default {
  name: "Home",
  data: function () {
    return {
      dateStamp: new Date().getFullYear(),
    };
  },
};
</script>

<!-- Style -->
<style>
</style>